import React from 'react';
import { defaultMemoize } from 'reselect';
import _ from 'underscore';

import { ServerUrls } from '~commonInfra/url/ServerUrls';
import { AllUserIdentitiesSubspace } from '~src/authentication/components/userIdentitiesSpace/AllUserIdentitiesSubspace';
import { Messages } from '~src/codegen/Localize';
import { BreadcrumbStateInfo } from '~src/spacesPlatform/components/breadcrumbs/BreadcrumbStateInfo';
import { SpaceHeaderWithTotalItemsCount } from '~src/spacesPlatform/components/header/SpaceHeaderWithTotalItemsCount';
import { Subspace, TabbedSpace } from '~src/spacesPlatform/components/spaceComponents/TabbedSpace';
import { ISelectFilterDefinitionOption } from '~src/spacesPlatform/services/FilterPanelService';
import { FilterMap } from '~src/spacesPlatform/state/ContentExplorerState';
import { SpaceInfo, SubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

import { AllServerUsersSpace } from '../../../../userManagement/users/components/serverAllUsersSpace/AllServerUsersSpace';

export interface AllServerUsersAndIdentitiesSpaceOwnProps {
}

export interface AllServerUsersAndIdentitiesSpaceStateProps {
  readonly spaceInfo: SpaceInfo;
  readonly isBusyFetchingItems: boolean;
  readonly numberOfFetchedUsers: number;
  readonly mixedContentFilterMap: FilterMap;
}

export interface AllServerUsersAndIdentitiesSpaceDispatchProps {
  readonly requestSpaceContents: () => void;
  readonly updateBreadcrumbs: (breadcrumbs: ReadonlyArray<BreadcrumbStateInfo>) => void;
  readonly updateTotalUserCountForServerUserSpace: (maxSiteRole?: string, maxSiteRoleCounts?: ISelectFilterDefinitionOption<string>[]) => void;
}

export type AllServerUsersAndIdentitiesSpaceProps = AllServerUsersAndIdentitiesSpaceOwnProps & AllServerUsersAndIdentitiesSpaceStateProps & AllServerUsersAndIdentitiesSpaceDispatchProps;

export class AllServerUsersAndIdentitiesSpace extends React.PureComponent<AllServerUsersAndIdentitiesSpaceProps> {
  private memoizedGetServerUsersSubspaces = defaultMemoize(getAllServerUsersSubspaces);

  public constructor(props: AllServerUsersAndIdentitiesSpaceProps) {
    super(props);
  }

  public componentDidMount() {
    this.props.requestSpaceContents();
  }

  public render(): JSX.Element {
    const header = <SpaceHeaderWithTotalItemsCount
      label={Messages.serverUsers()}
      testId={'server-users'}
      count={this.props.numberOfFetchedUsers}
      onClick={null}
      countUpToDate={!this.props.isBusyFetchingItems}
      shouldHideCount={this.props.spaceInfo.subspaceName === 'identities'}
    />;
    const subspaces = this.memoizedGetServerUsersSubspaces(this.props);
    return (
      <TabbedSpace
        subspaces={subspaces}
        activeSubspaceName={this.props.spaceInfo.subspaceName}
        urlForSubspace={getAllServerUsersSubspaceUrl}
        mastheadElement={header}
        testIdPrefix={'all-server-users-and-identities-tabbed-space'}
        spaceItemName={''}
      />
    );
  }
}

function getAllServerUsersSubspaceUrl(subspaceName?: SubspaceName): string {
  if (subspaceName === 'list') {
    return ServerUrls.getInstance().usersUrl();
  } else if (subspaceName === 'identities') {
    return ServerUrls.getInstance().allUserIdentitiesUrl();
  } else {
    return '';
  }
}

function getAllServerUsersSubspaces(props: AllServerUsersAndIdentitiesSpaceProps): ReadonlyArray<Subspace> {
  return _.compact([
    {
      name: 'list',
      tabLabel: Messages.userList(),
      shouldRenderTabContentCount: false,
      renderContent: () => (<AllServerUsersSpace {...props} shouldRenderAsSubspace={true} />)
    } as const,
    {
      name: 'identities',
      tabLabel: Messages.identityMigration(),
      shouldRenderTabContentCount: false,
      renderContent: () => (<AllUserIdentitiesSubspace {...props} subspaceHref={ServerUrls.getInstance().allUserIdentitiesUrl()}/>)
    } as const,
  ]);
}
